import { render, staticRenderFns } from "./FootprintPage.vue?vue&type=template&id=05014969&scoped=true&"
import script from "./FootprintPage.vue?vue&type=script&lang=js&"
export * from "./FootprintPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05014969",
  null
  
)

export default component.exports